<template>
    <section class="card-clothes _mini">
        <VueSlickCarousel v-bind="settings" class="slider slider-carousel" v-if="sliderItems.length > 0">
            <a class="carousel-items__slider-item link"
               v-for="sliderItem of sliderItems"
               :href="sliderItem.full">
                <img class="carousel-items__slider-item-img" :src="sliderItem.thumb">
            </a>
            <template #prevArrow="arrowOption">
                <button type="button" class="slick-arrow _prev">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider"/>
                    </svg>
                </button>
            </template>
            <template #nextArrow="arrowOption">
                <button type="button" class="slick-arrow _next">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider"/>
                    </svg>
                </button>
            </template>
        </VueSlickCarousel>
    </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import SimpleLightbox from 'simple-lightbox'

export default {
    name: 'gallerySlider',
    props: ['id'],
    components: {VueSlickCarousel, SimpleLightbox},
    created() {
        this.$http.get('/api/products/' + this.id + '/second-gallery').then(res => {
            this.sliderItems = res.data
        })
    },

    data() {
        return {
            settings: {
                arrows: false,
                dots: true,
                infinite: true,
                slidesToScroll: 5,
                slidesToShow: 5,
                lazyLoad: "ondemand",
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 994,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                ]
            },
            sliderItems: [],
        }
    },
}
</script>
